import { Phone } from "lucide-react";

// Schwebender Beratungs-Button (alle Seiten, unten rechts).
export const FloatingConsultButton = () => (
  <a
    href="https://crm.dickies-campus.de/termin"
    data-testid="floating-consult-btn"
    aria-label="Kostenlose Beratung buchen"
    className="fixed z-50 right-5 bottom-[84px] md:bottom-5 inline-flex items-center gap-2.5 rounded-full bg-terra hover:bg-terra-dark text-white font-semibold text-[14px] sm:text-[15px] pl-4 pr-5 py-3 shadow-[0_6px_24px_rgba(141,75,50,0.35)] transition-transform duration-200 hover:scale-105 focus-visible:scale-105"
  >
    <span className="inline-flex items-center justify-center h-7 w-7 rounded-full bg-white/15 shrink-0">
      <Phone className="h-4 w-4" strokeWidth={2} />
    </span>
    Kostenlose Beratung buchen
  </a>
);
